import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

interface IHorizontalSeparatorProps {
  className?: string
}

const HorizontalSeparator = ({ className }: IHorizontalSeparatorProps) => {
  return <div className={clsx(s.bar, className)}></div>
}

export default HorizontalSeparator
